import { DealerInfoResponse } from '@dav-model/api/response/dealer-info.response.model';
import { RecentQuotes } from '@dav-model/api/response/recent-quotes.response.model';
import { OktaLoginRequest } from '@dav-model/login/request/okta-login.request';
import { UserResponse, Markup } from '@dav-model/login/response/user.response.model';
import { Action } from '@ngrx/store';

/**
 * User login store.
 * UI will call API and
 * return all information that is associated to that user if authenticated.
 */
export const LOGIN = '[User] LOGIN';
export const LOGOUT = '[User] LOGOUT';
export const LOGOUT_SUCCESS = '[User] LOGOUT_SUCCESS';
export const GET_RECENT_QUOTES = '[User] GET RECENT QUOTES';
export const GET_RECENT_QUOTES_SUCCESS = '[User] GET RECENT QUOTES SUCCESS';
export const GET_QUOTE = '[User] GET QUOTE';
export const DELETE_QUOTE = '[User] DELETE QUOTE';
export const DELETE_QUOTE_SUCCESS = '[User] DELETE QUOTE SUCCESS';
export const UPDATE_PASSWORD = '[User] UPDATE PASSWORD';
export const LOGIN_SUCCESS = '[User] LOGIN SUCCESS';
export const SET_APP_VERSION = '[User] SET APP VERSION';
export const LOGIN_FAILURE = '[User] LOGIN FAILURE';
export const DECODE_TOKEN = '[User] DECODE TOKEN';
export const RESET_SESSION = '[User] RESET SESSION';
export const UPDATE_VEHICLE_INFO = '[User] UPDATE VEHICLE INFO';
export const SAVE_MARKUP = '[Profile] SAVE MARKUP';
export const UPDATE_PENDING_NUMBER = '[Remit] UPDATE PENDING NUMBER';
export const EMULATE_DEALER = '[Profile] EMULATE DEALER';
export const EMULATE_DEALER_SUCCESS = '[Profile] EMULATE DEALER SUCCESS';
export const RESET_DEALER = '[Profile] RESET DEALER';
export const UPDATE_PREVIOUS_USER = '[User] UPDATE PREVIOUS USER';
export const UPDATE_VERSION = '[User] UPDATE APP VERSION';

export const SSO_LOGIN = '[User] SSO LOGIN';
export const SSO_LOGIN_FAILURE = '[User] SSO LOGIN FAILURE';

export const SSO_OKTA_LOGIN = '[User] SSO OKTA LOGIN';
export const SSO_OKTA_LOGIN_FAILURE = '[User] SSO OKTA LOGIN FAILURE';
export const SSO_OKTA_VALIDATE_PASSWORD_RESET_TOKEN = '[User] SSO VALIDATE OKTA PASSWORD RESET TOKEN';

export class LogInAction implements Action {
  readonly type = LOGIN;

  constructor(public payload: { username: string; password: string; admin?: boolean; captcha: string }) {}
}

export class SSOLogInAction implements Action {
  readonly type = SSO_LOGIN;
}

export class SSOLogInFailureAction implements Action {
  readonly type = SSO_LOGIN_FAILURE;

  constructor(public payload: any) {}
}

export class SsoOktaLoginAction implements Action {
  readonly type = SSO_OKTA_LOGIN;

  constructor(public payload: { oktaLoginRequest: OktaLoginRequest }) {}
}

export class SsoOktaLoginFailureAction implements Action {
  readonly type = SSO_LOGIN_FAILURE;
}

export class LogOutAction implements Action {
  readonly type = LOGOUT;

  constructor(public payload: { newVersion: boolean; version: string } = { newVersion: false, version: '' }) {}
}

export class LogOutSuccessAction implements Action {
  readonly type = LOGOUT_SUCCESS;
}

export class UpdatePreviousUserAction implements Action {
  readonly type = UPDATE_PREVIOUS_USER;

  constructor(public payload: string) {}
}

export class UpdateVersionAction implements Action {
  readonly type = UPDATE_VERSION;

  constructor(public payload: string) {}
}

export class GetRecentQuotesAction implements Action {
  readonly type = GET_RECENT_QUOTES;
}

export class GetRecentQuotesSuccessAction implements Action {
  readonly type = GET_RECENT_QUOTES_SUCCESS;

  constructor(public payload: RecentQuotes[]) {}
}

export class GetQuoteAction implements Action {
  readonly type = GET_QUOTE;

  constructor(public payload: { dealer: string; vin: string }) {}
}

export class SetAppVersionAction implements Action {
  readonly type = SET_APP_VERSION;

  constructor(public payload: string) {}
}

export class EmulateDealerAction implements Action {
  readonly type = EMULATE_DEALER;

  constructor(public dealer: DealerInfoResponse) {}
}

export class EmulateDealerSuccessAction implements Action {
  readonly type = EMULATE_DEALER_SUCCESS;

  constructor(public user: UserResponse) {}
}

export class ResetDealerAction implements Action {
  readonly type = RESET_DEALER;
}

export class DeleteQuoteAction implements Action {
  readonly type = DELETE_QUOTE;

  constructor(public payload: { dealer: string; vin: string }) {}
}

export class DeleteQuoteSuccessAction implements Action {
  readonly type = DELETE_QUOTE_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdatePasswordAction implements Action {
  readonly type = UPDATE_PASSWORD;

  constructor(public payload: { response: UserResponse; admin: boolean }) {}
}

export class LogInSuccessAction implements Action {
  readonly type = LOGIN_SUCCESS;

  constructor(public payload: { response: UserResponse; admin: boolean }) {}
}

export class LogInFailureAction implements Action {
  readonly type = LOGIN_FAILURE;

  constructor(public payload: any) {}
}

export class DecodeTokenAction implements Action {
  readonly type = DECODE_TOKEN;

  constructor(public payload: string) {}
}

export class SaveMarkupAction implements Action {
  readonly type = SAVE_MARKUP;

  constructor(public payload: Markup) {}
}

export class UpdatePendingNumberAction implements Action {
  readonly type = UPDATE_PENDING_NUMBER;

  constructor(public payload: number) {}
}

export class ResetSessionAction implements Action {
  readonly type = RESET_SESSION;
}

export class UpdateVehicleInfoAction implements Action {
  readonly type = UPDATE_VEHICLE_INFO;
}

export class SsoValidateOktaPasswordResetTokenreAction implements Action {
  readonly type = SSO_OKTA_VALIDATE_PASSWORD_RESET_TOKEN;

  constructor(public payload: { token: string }) {}
}

export type All =
  | LogInAction
  | LogOutAction
  | LogInSuccessAction
  | LogInFailureAction
  | DecodeTokenAction
  | ResetSessionAction
  | GetRecentQuotesSuccessAction
  | LogOutSuccessAction
  | SetAppVersionAction
  | SaveMarkupAction
  | UpdatePreviousUserAction
  | UpdateVersionAction
  | DeleteQuoteSuccessAction
  | UpdateVehicleInfoAction
  | UpdatePasswordAction
  | EmulateDealerAction
  | EmulateDealerSuccessAction
  | ResetDealerAction
  | SSOLogInAction
  | SSOLogInFailureAction
  | UpdatePendingNumberAction
  | SsoOktaLoginAction
  | SsoOktaLoginFailureAction;
